// extracted by mini-css-extract-plugin
export default {"panel":"MoreTabPanel_panel__2x6QS"};